<template>
  <div class="content">
    <div class="content_middle">
      <p class="content_middle_title page_color_1C2438">身份证照片</p>
      <ul>
        <li
          class="se_bg"
          id="se_bg_pufa"
        >
          <input
            id="uploaderInputSecond"
            class="input uploaderInputSecond"
            type="file"
            accept="image/*"
            @change="showPositiveImage"
          />
          <img
            :src="positive"
            v-if="positive"
            style="position: absolute;top: 0;left: 0;width: 216px;height:142px"
          />
        </li>
        <p class="instruction">请上传身份证人像面</p>
        <li
          class=" mgt_15 fs_bg"
          id="fs_bg_pufa"
        >
          <input
            id="uploaderInputFirst"
            class="input uploaderInputFirst"
            type="file"
            accept="image/*"
            
            @change="showNegativeImage"
          />
          <img
            :src="negative"
            v-if="negative"
            style="position: absolute;top: 0;left: 0;width: 216px;height:142px"
          />
        </li>
        <p class="instruction">请上传身份证国徽面</p>
      </ul>
    </div>
    <Button
      :loading="Isloading"
      loadingText="提交中..."
      :text="draw"
      :type="danger"
      :disabled="Isloading"
      class="nextStep"
      :click="submit"
    />
  </div>
</template>
<script>
import { Toast } from 'vant';
import service from '@/request/api'; // 导入api接口
import Button from '@/components/Button.vue';
import { checkStatus } from '@/views/pages/commonPage/mixin';

export default {
  name: 'IdentifyCardUpload',
  data() {
    return {
      positive: '',
      idFrontPic: '',
      negative: '',
      idBackPic: '',
      danger: 'danger',
      draw: '下一步',
      Isloading: false,
    };
  },
  components: {
    Button,
  },
  mixins: [checkStatus],
  mounted() {
    const { orderId } = this.$router.currentRoute.query;
    this.$api.CommonForms.getUploadIdentityUrl({ orderId }).then((res) => {
      const { idFrontPic, idBackPic } = res.data;
      this.positive = idFrontPic;
      this.negative = idBackPic;
    });
  },
  methods: {
    showPositiveImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idFrontPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          console.log(item);
          self.positive = item.target.result; // 图片内容的base64编码
          console.log(self.positive);
        };
      }
    },
    showNegativeImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idBackPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.negative = item.target.result; // 图片内容的base64编码
          console.log(self.positive);
        };
      }
    },
    validate_img(file) {
      if (!/.(jpg|png|jpeg)$/i.test(file.name)) {
        Toast('请上传正确格式的个人头像');
        return false;
      }
      if (file.size.toFixed(5) >= 5 * 1024 * 1024) {
        Toast('请上传小于5M的图片');
        return false;
      }
      return true;
    },
    jumpThirdFc(orderId) {
      service.CommonForms.jumpThirdServer({ orderId }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          console.log(res);
          Toast(res.returnMessage || '上传失败');
        }
      });
    },
    // eslint-disable-next-line consistent-return
    submit() {
      if (!this.positive) {
        return Toast('请上传身份证人像面的图片');
      }
      if (!this.negative) {
        return Toast('请上传身份证国徽面');
      }
      if (this.positive && this.negative) {
        const form = new FormData();
        let { negative } = this;
        let { positive } = this;
        if (this.idFrontPic) {
          positive = '';
        }
        if (this.idBackPic) {
          negative = '';
        }
        form.append('orderId', this.$router.currentRoute.query.orderId);
        form.append('idFrontPicData', this.idFrontPic);
        form.append('idBackPicData', this.idBackPic);
        form.append('idBackPic', negative);
        form.append('idFrontPic', positive);
        this.Isloading = true;
        this.$api.CommonForms.openBankIdentityPicService(form).then((res) => {
          if (res.success) {
            this.$router.push(
              `/supermarket/v2/OpenAccountApply?orderId=${this.$router.currentRoute.query.orderId}`,
            );
            this.Isloading = false;
            // this.jumpThirdFc(orderId || localStorage.getItem('orderId'))
          } else {
            this.Isloading = false;
            Toast(res.returnMessage || '上传失败');
          }
        });
      }
    },
  },
};
</script>
<style scoped>
/* 身份认证 */
body {
  background-color: #f8f8f9;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.content_middle {
  box-sizing: border-box;
  padding-right: 15px;
  padding-left: 15px;
  background: #fff;
}

.content_middle_title {
  margin: 0;
  padding: 13px 0;
  font-size: 17px;
  text-align: left;
}

.content_middle ul {
  text-align: center;
  background: #fff;
}

.content_middle ul li {
  position: relative;
  box-sizing: border-box;
  width: 216px;
  height: 142px;
  margin: 0 auto;
  overflow: hidden;
}

.content_bottom {
  margin-top: 0.08rem;
  padding: 0 0.15rem;
}

.btnBox {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.2rem;
  margin-bottom: 0.35rem;
  padding: 0 15px;
}

.btn {
  display: block;
  width: 100%;
  height: 44px;
  padding: 0;
  color: #fff;
  font-size: 17px;
  line-height: 44px;
  text-align: center;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 4px;
}

/* 文字颜色 */
.page_color_F65249 {
  color: #ff6538;
}

.page_color_A1A9B6 {
  color: #a1a9b6;
}

.page_color_A5ADB9 {
  color: #a5adb9;
}

.page_color_1C2438 {
  color: #1c2438;
}

.fs_bg {
  background: url("~@/assets/images/back.png") center center;
  background-size: cover;

  /* border: 1px dashed #979797; */
  border-radius: 0.08rem;
}

.se_bg {
  margin-top: 0.08rem;
  background: url("~@/assets/images/positive.png") center center;
  background-size: cover;
  border-radius: 0.08rem;
}

/* 文字大小 */
.page_fs_14 {
  font-size: 0.14rem;
}

.mgt_15 {
  margin-top: 0.15rem;
}

.mgb_15 {
  margin-bottom: 0.15rem;
}

.mgt_8 {
  margin-top: 0.08rem;
}

/* input */
.input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.instruction {
  color: #838d9b;
  font-size: 13px;
}
</style>
